import { Link } from "react-router-dom";

interface CategoryHeaderProps {
  name: string;
  icon: string;
  description: string;
  count: number;
  image: string;
}

export default function CategoryHeader({
  name,
  icon,
  description,
  count,
  image,
}: CategoryHeaderProps) {
  return (
    <section className="relative w-full h-[280px] md:h-[340px] overflow-hidden">
      <img
        src={image}
        alt={name}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="absolute bottom-0 left-0 right-0 px-6 md:px-10 pb-8 md:pb-10">
        <div className="max-w-[1200px] mx-auto w-full">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-xl">
              <i className={`${icon} text-lg text-background-50 dark:text-foreground-950`}></i>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-white">
              {name}
            </h1>
          </div>
          <p className="text-sm md:text-base text-white/75 max-w-[600px] mb-3 leading-relaxed">
            {description}
          </p>
          <span className="inline-flex items-center gap-1.5 text-xs text-white/55">
            <i className="ri-article-line"></i>
            共 {count.toLocaleString()} 篇文章
          </span>
        </div>
      </div>
    </section>
  );
}